import { render } from "./OrderManagement.vue?vue&type=template&id=1851f30a&scoped=true"
import script from "./OrderManagement.vue?vue&type=script&lang=js"
export * from "./OrderManagement.vue?vue&type=script&lang=js"

import "./OrderManagement.vue?vue&type=style&index=0&id=1851f30a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1851f30a"]])

export default __exports__